import { z } from 'zod'

export const PostcodeNotFoundSchema = z.object({
  errorResolutionType: z.literal('POSTCODE_NOT_FOUND'),
})
